function request({url, type = 'GET', body = null}) {
    if (!url) {
        return;
    }

    const config = {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
        },
        method: type
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    return fetch(url, config).then(function(response) {
        return response.json();
      }).catch(function(err) {
        /* uh oh, we have error. */
        console.error(err)
        return err;
      });
}


function parseUrl(url) {
    if(!url) url = location.search;
    var query = url.substr(1);
    var result = {};
    query.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

function createEvent(name,{ bubbles, detail }) {
    return new CustomEvent(name, {
        bubbles,
        detail,
     });     
}

const validate = {
    key(key) {
        if (typeof key !== 'string' || key.split(':').length !== 2) {
          throw new TypeError(
            'Theme Cart: Provided key value is not a string with the format xxx:xxx'
          );
        }
    },

    quantity(quantity) {
        if (typeof quantity !== 'number') {
          throw new TypeError(
            'Theme Cart: An object which specifies a quantity or properties value is required'
          );
        }
    },

    number(value) {
        return (typeof value !== 'number');
    },

    id(id) {
        if (typeof id !== 'number') {
          throw new TypeError('Theme Cart: Variant ID must be a number');
        }
    },

    properties(properties) {
        if (typeof properties !== 'object') {
          throw new TypeError('Theme Cart: Properties must be an object');
        }
    },

    options(options) {
        if (typeof options !== 'object') {
          throw new TypeError('Theme Cart: Options must be an object');
        }
      
        if (
          typeof options.quantity === 'undefined' &&
          typeof options.properties === 'undefined'
        ) {
          throw new Error(
            'Theme Cart: You muse define a value for quantity or properties'
          );
        }
      
        if (typeof options.quantity !== 'undefined') {
          this.quantity(options.quantity);
        }
      
        if (typeof options.properties !== 'undefined') {
          this.properties(options.properties);
        }
    }
}

const AjaxCart = {
    async addItems(items) {
        const send = {
            url: '/cart/add.js',
            type: 'POST',
            body: { 
                items 
            },
        }
    
        console.log('Add', send, items);
    
        const cart = await request(send);
    
        console.warn('We Added', cart);
        
        const addEvent = createEvent('cartAdd', {
            detail: {
                added: cart,
            }
        });
        
        document.body.dispatchEvent(addEvent);
    
        return cart;
    },

    clearAttributes() {
        return getAttributes().then(function(attributes) {
          for (var key in attributes) {
            attributes[key] = '';
          }
          return updateAttributes(attributes);
        });
    },

    async clearCart() {
        const send = {
            url: '/cart/clear.js',
            type: 'POST'
        };
        
        const cart = await request(send);
    
        return cart;
    },

    clearNote() {
        const send = {
            url: '/cart/update.js',
            type: 'POST',
            body:  {
                note: '',
            }
        }
    
        return request(send);
    },

    getAttributes() {
        return getCart().then(function(cart) {
          return cart.attributes;
        });
    },

    async getCart() {
        const send = {
            url: '/cart.js',
        };
    
        const cart = await request(send);
    
        const cartEvent = createEvent('cartData', {
            detail: {
               cart,
            }
        });
        
        document.body.dispatchEvent(cartEvent);
    
        return cart;
    },

    getItem(key) {
        validate.key(key);
      
        return getCart().then(function(state) {
          var lineItem = null;
      
          state.items.forEach(function(item) {
            lineItem = item.key === key ? item : lineItem;
          });
      
          if (lineItem === null) {
            return Promise.reject(
              new Error('Cart: Unable to match line item with provided key')
            );
          }
      
          return lineItem;
        });
    },

    async updateAttributes(attributes) {

        const send = {
            url: '/cart/update.js',
            type: 'POST',
            body:  {
                attributes,
            }
        }
    
        const update = await request(send);
    
    
        const addEvent = createEvent('cartUpdate', {
            detail: {
                update,
            }
        });
        
        document.body.dispatchEvent(addEvent);
    
        return update;
    },

    updateItem(line, options) {
        validate.options(options);
    
        const send = {
            url: '/cart/change.js',
            type: 'POST',
            body: {
                line,
                quantity: options.quantity
            }
        }
    
        if (options.properties) {
            send.body.properties = options.properties;
        }
    
        return request(send).then(function(cart) {
    
            const addEvent = createEvent('cartUpdate', {
                detail: {
                    update: cart,
                }
            });
            
            document.body.dispatchEvent(addEvent);
    
          return cart;
        });
    },

    updateItemById(id, options) { 
        console.log('Update by Id', options);
        validate.options(options);
    
        const send = {
            url: '/cart/update.js',
            type: 'POST',
            body: {
                updates: {
                    [id]: options.quantity,
                },
            },
        }
    
        return request(send).then(function(cart) {
    
            const addEvent = createEvent('cartUpdate', {
                detail: {
                    update: cart,
                }
            });
            
            document.body.dispatchEvent(addEvent);
    
          return cart;
        });
    },

    async updateNote(note) {

        const send = {
            url: '/cart/update.js',
            type: 'POST',
            body:  {
                note,
            }
        }
    
        const update = await request(send);
    
    
        const addEvent = createEvent('cartUpdate', {
            detail: {
                update,
            }
        });
        
        document.body.dispatchEvent(addEvent);
    
        return update;
    },

    removeItem(line) {

        const send = {
            url: '/cart/change.js',
            type: 'POST',
            body: {
                line,
                quantity: 0
            }
        }
    
        return request(send).then(function(cart) {
    
            const addEvent = createEvent('cartUpdate', {
                detail: {
                    update: cart,
                }
            });
            
            document.body.dispatchEvent(addEvent);
    
          return cart;
        });
    }
}


class MultiGWP {
    constructor({ container }) {

        this.cart = null;
        this.campaignID = this.getStoredCampaign();
        this.campaignVariant = this.getStoredVariation();
        this.currentGWP = null;
        this.gwpProduct = null;
        this.gwpRequiredProduct = null;
        this.userIsQualified = false;
        this.container = container;
        this.data = JSON.parse(container.querySelector('script[gwp-data]').innerHTML);

        
        this.initialize = this.initialize.bind(this);
        this.cartEvents = this.cartEvents.bind(this);
        this.productWindow = this.productWindow.bind(this);
        this.multiVariantWindow = this.multiVariantWindow.bind(this);

        this.initialize();
    }

    async initialize() {

        this.getUserCampaign();
        this.cartEvents();

        console.log('GWP Data', this.data, this.currentGWP);

        this.cart = await this.getCart();
        if (this.currentGWP) {
            this.gwpProduct = await this.getGWPJson(this.currentGWP.product);
            if (this.currentGWP.type == 'specific_item') {
                this.gwpRequiredProduct = await this.getGWPJson(this.currentGWP.required_product);
            }
        }

        this.checkQualifications();
        this.scanForUpdate();
    }

    async checkQualifications() { 
        const currentGWP = this.currentGWP;
        const cart = await this.getCart();

        console.log('Current GWP?', this.gwpProduct);

        if(!this.gwpProduct) return;
        
        const gwpInCart = cart.items.find((item) => item.product_id === this.gwpProduct.id);

        console.warn('Check Qualifications', currentGWP, cart.items.length);

        console.log('Qualification Check', { cart, gwpInCart, currentGWP });

        if (currentGWP.type == 'all' && cart.items.length > 0) {
            console.log('Inside All Qualified', cart, (cart.items.length === 1 && gwpInCart), gwpInCart);
            if (cart.items.length === 1 && gwpInCart) {
                this.userIsQualified = false; 
                console.log('Returning User as Not Qualified');
                return false;
            }

            this.userIsQualified = true;
            return true;
        }

        // item_count restriction.
        if (currentGWP.type == 'item_count') {
            const totalCartQuantity = [...cart.items].reduce((total, item) => {
                total += item.quantity;
                return total;
            }, 0);

            const itemCount = (gwpInCart) ? totalCartQuantity - gwpInCart.quantity : totalCartQuantity; 
            const userQualified = currentGWP.item_count <= itemCount;

            this.userIsQualified = userQualified;
            return userQualified;
        }

        if (currentGWP.type == 'cart_total') {
            const cartTotal = cart.total_price - (gwpInCart ? gwpInCart.price : 0);
            const gwpCartTotal = currentGWP.cart_total;
            const userQualified = gwpCartTotal <= cartTotal;

            this.userIsQualified = userQualified;
            return userQualified;
        }

        if (currentGWP.type == 'specific_item') {
            const requiredProductInCart = cart.items.find((item) => item.product_id === this.gwpRequiredProduct.id);
            const enoughRequiredQuantity = currentGWP.min_item_count <= requiredProductInCart.quantity;
            
            this.userIsQualified = enoughRequiredQuantity;
            return enoughRequiredQuantity;
        }



        return false;
    }

    getCart() {
        console.log('Fetch Fetch', `https://${location.host}/cart.js`);

        return fetch(`https://${location.host}/cart.js`)
                .then(res => res.json())
                .then(cart => {
                    this.cart = cart;
                    return cart;
                })
                .catch(() => {});
    }

    getGWPJson(handle) {
        return fetch(`/products/${handle}.js`)
                .then(res => res.json())
                .catch(() => {});
    }

    cartEvents() {
        // all events
        /**
         *  beforeUpdateCartNote.ajaxCart
         *  afterUpdateCartNote.ajaxCart
         *  beforeAddItem.ajaxCart (form)
         *  afterAddItem.ajaxCart ([line_item, form])
         *  beforeGetCart.ajaxCart
         *  afterGetCart.ajaxCart (cart)
         *  beforeChangeItem.ajaxCart
         *  afterChangeItem.ajaxCart ([ line, quantity, cart ])
         *  afterCartLoad.ajaxCart (cart) 
         *  beforeDrawerOpen.timber (drawer)
         */

        console.log('Assgin CartEvents');

        // $('body').on('afterGetCart.ajaxCart', this.saveLocalCart.bind(this));
        // $('body').on('beforeDrawerOpen.timber', this.drawerOpening);
        // $('body').on('afterAddItem.ajaxCart', this.cartItemAddedCallback.bind(this));
        // $('body').on('afterChangeItem.ajaxCart', this.cartItemAddedCallback.bind(this));
    }

    saveLocalCart(event, cart) {
        this.cart = cart;
    }

    drawerOpening(event, drawer) {
        // console.log('Drawer Opening', event, drawer);
    }

    async cartItemAddedCallback() {
        this.cart = await this.getCart();

        console.log('Item Added Callback');
        this.checkQualifications();
        this.scanForUpdate();
    }

    async updateGWPQuantity(quantity) {
        const cart = this.cart;
        const gwpInCart = cart.items.find((item) => item.product_id === this.gwpProduct.id);
        console.log('Update GWP Quantity??');

        const cartUpdate = await AjaxCart.updateItemById(gwpInCart.variant_id, { quantity: 0 });

        if(window.location.pathname.indexOf('/cart') !== -1) {
            window.location.reload();
        } else {
            document.querySelector('a[href="/cart"]').click();
        }


        return cartUpdate;
    }

    productWindow(product) {
        console.log('Product Window', product);
        const innerContainer = document.createElement('div');
        innerContainer.classList.add('gwp-product-wrapper');
    
        innerContainer.innerHTML = `
          <div class="images">
            <div class="image-slide">
                <img src="${product.images[0]}" />
            </div>
          </div>
          <div class="content">
            <h5>${product.title}</h5>
            <label for="size-selection">Pick a size</label>
            <select id="size-selection">
              ${product.variants.map(function(variant) {
                return `
                  <option value="${variant.id}">${variant.title}</option>
                `
              }).join('')}
            </select>
            <button type="button" class="add-gwp">Add To Cart</button>
          </div>
        `;
    
    
        innerContainer.querySelector('.add-gwp').addEventListener('click',async (event) => {
          const variantID = innerContainer.querySelector('select').value;
          const variant = product.variants.find(function(vari) {
            return vari.id == variantID;
          });
          const modal = document.querySelector('.gwp-modal');
    
    
          console.warn('Add', variant);

          await this.addGWPToCart(variant.id);

          if(window.location.pathname.indexOf('/cart') !== -1) {
              window.location.reload();
          }
    
          const newCart = await this.getCart();

        //   window.refreshCart(newCart);

          document.body.removeChild(modal);
        });
    
    
        return innerContainer;
    }


    multiVariantWindow(product) {
        const modal = document.createElement('div');
        modal.classList.add('gwp-modal'); 
    
    
        modal.innerHTML = `
          <div class="inner-gwp-modal">
            <div class="stage-one">
              <h5>You are eligible for a free gift!</h5>
              <button type="button" class="gwp-activate">Select Size</button>
            </div>
            <div class="stage-two"></div>
    
          </div>
        `;
    
    
        const activateModalHandler = function(event) {
            event.preventDefault();
            const modal = document.querySelector('.inner-gwp-modal');
        
            modal.classList.add('active');
        
            $('.inner-gwp-modal .images').slick();
        };

        modal.querySelector('.gwp-activate').addEventListener('click', activateModalHandler);
        modal.querySelector('.stage-two').appendChild(this.productWindow(product))
    
    
        document.body.appendChild(modal);
    
        modal.addEventListener('click', function(event) {
          const target = event.target;
          const innerModal = modal.querySelector('.inner-gwp-modal')
    
          if (!innerModal.contains(target)) {
            document.body.removeChild(modal);
          }
        });
    }

    async addGWPToCart(variant = null) {
        const gwpProduct = this.gwpProduct;

        console.log('Add GWP To Product', gwpProduct);
    

        if(!variant) {
            variant = [...gwpProduct.variants].find((variant) => variant.available);
        }

        const add = {
            quantity: 1,
            id: (variant) ? variant.id : gwpProduct.variants[0].id,
            properties: {
                'Gift With Purchase': 'Eligible',
            }
        }; 

        const cartUpdate = await AjaxCart.addItems([add]);

        if(window.location.pathname.indexOf('/cart') !== -1) {
            window.location.reload();
        } else {
            document.querySelector('a[href="/cart"]').click();
        }

        return cartUpdate;
    }

    async scanForUpdate() {
        const currentGWP = this.currentGWP;
        const cart = await this.getCart();

        if(!currentGWP) return;

        const gwpInCart = cart.items.find((item) => item.product_id === this.gwpProduct.id);

        await this.checkQualifications();
        console.log('Something updated, scan the cart for qualifications & gwp actions', currentGWP, cart, this.gwpProduct, this.userIsQualified);
    

        if (!this.userIsQualified) {
            console.log('User Not Qualified. Item In Cart?', gwpInCart);

            if (gwpInCart) {
                // user is not qualified and GWP is in cart. Remove it.
                console.log('GWP Is In Cart, Removing');
                 
                const cartUpdate = await this.updateGWPQuantity(0);
                this.saveLocalCart(cartUpdate);
                 
                if(window.location.pathname.indexOf('/cart') > -1) {
                    window.location.reload();
                } else {
                    document.querySelector('a[href="/cart"]').click();
                }
                
                //  window.refreshCart(cartUpdate);
            }
            
            // user wasn't qualified. Exit process.
            return;
        }

        console.log('GWP In Cart', gwpInCart, this.userIsQualified);

        if (gwpInCart && gwpInCart.quantity > 1) {
            // too many gwp quantity in cart, reduce to 1.
            const cartUpdate = await this.updateGWPQuantity(1);
            this.saveLocalCart(cartUpdate);
            return;
        }

        if (!gwpInCart) {
            // user is qualified, and GWP is not in cart yet. Add it. 
            const cartUpdate = await this.addGWPToCart();
            const newCart = await this.getCart();

            console.log('Cart Was Updated?', newCart);
            //  window.refreshCart(newCart);
            this.saveLocalCart(newCart);
        }



    }

    eraseCookie(cookieKey) {
        document.cookie = cookieKey +'=; Max-Age=-99999999;';  
    }
    
    setCookie(cookieKey, cookieValue, expirationDays){
        let expiryDate = '';
      
        if (expirationDays) {
          const date = new Date();
      
          date.setTime(`${date.getTime()}${(expirationDays || 30 * 24 * 60 * 60 * 1000)}`);
      
          expiryDate = `; expiryDate=" ${date.toUTCString()}`;
        }
      
        document.cookie = `${cookieKey}=${cookieValue || ''}${expiryDate}; path=/`;
      }
    
    getCookie(cookieKey) {
        let cookieName = `${cookieKey}=`; 
      
        let cookieArray = document.cookie.split(';');
      
        for (let cookie of cookieArray) {
      
          while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
      
          if (cookie.indexOf(cookieName) == 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
    }

    getStoredVariation() {
        const urlData = parseUrl();

        if (urlData.variation) {
            return urlData.variation;
        }

        return this.getCookie('gwp_variation');
    }

    getStoredCampaign() {
        const urlData = parseUrl();

        console.log('Url Data', urlData);
        if (urlData.utm_campaign) {
            this.setStoredCampaign(urlData.utm_campaign);

            return urlData.utm_campaign;
        }

        return this.getCookie('gwp_campaign');
    }

    setStoredVariation(variation) {
        this.setCookie('gwp_variation', variation);

        return variation;
    }

    setStoredCampaign(campaign) { 
        // localStorage.setItem('TLL_GWP', campaign);

        this.setCookie('gwp_campaign', campaign)
        return campaign;
    }

    getUserCampaign() {
        const {  campaignID, data, campaignVariant } = this;
      
      let variation = campaignVariant;
      
        let gwpCampaign = [...data].find((gwp) => {
            if (variation) {
                return gwp.campaign == campaignID && variation == gwp.variation;
            }
            return gwp.campaign === campaignID;
        });

        if (!gwpCampaign) {
            gwpCampaign = [...data].find((gwp) => {
                return gwp.restrict === 'false';
            });
        }

        console.log('Is there a campaign?', {gwpCampaign, data, campaignID});
        

        if (!gwpCampaign) {
            return;
        }

        this.currentGWP = gwpCampaign;
        // if code makes it here, campaign has been identified. Proceed to GWP Logic.
        console.warn('User Campaign Search', data);
    }
}

